if (window.document.documentMode) {
   document.querySelector("#ieBanner").style.display = "flex";
   document.querySelector("#loginForm").style.pointerEvents = "none";
}
